import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GeneralPromptDialog } from '../components/dialogs/general-prompt-dialog/general-prompt.dialog';
import { GeneralPromptDialogDataModel } from '../components/dialogs/general-prompt-dialog/models/general-prompt-dialog-data.model';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private readonly matDialog = inject(MatDialog);

    showGeneralPromptDialog(config: GeneralPromptDialogDataModel, callback: (result: boolean) => void): void {
        const dialogRef = this.matDialog.open(GeneralPromptDialog, {
            data: config,
            disableClose: config.disableClose,
            maxWidth: 'min(600px, 98vw)',
            maxHeight: '98vh'
        });

        dialogRef.afterClosed().subscribe(result => callback(!!result));
    }
}
